import styled from 'styled-components';

export default styled.section`
  padding: 2.0625rem ${props => props.theme.padding.inner};
  background: ${props => props.background || props.theme.colors.white};
  overflow: visible !important;
  position: relative;
  z-index: 10;

  > .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    display: flex;
    flex-direction: column;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    > .content {
      flex: 0 0 auto;
      width: 100%;
      position: relative;
      z-index: 10;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        max-width: calc(100% - ${props => props.sidebarWidth} - 5.4375rem);
      }

      @media (prefers-reduced-motion: no-preference) {
        .isAnimated& {
          opacity: 0;
          transition: scale(1.2);
        }

        .active& {
          animation: 0.4s ease-in-out scale-in forwards;
        }
      }
    }
  }

  .sidebar {
    flex: 0 0 auto;
    box-sizing: border-box;
    width: 100%;
    order: ${props => (props.sidebarFirstOnMobile ? '-1' : '2')};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.sidebarWidth};
      order: ${props => (props.sidebarFirst ? '-1' : '2')};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: transformX(-10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-right forwards;
        animation-delay: 0.4s;
      }
    }
  }

  ${props => props.theme.animations.scaleIn};
  ${props => props.theme.animations.slideInRight};
`;
